export const ROLES = {
    ADMINISTRATOR: "Administrator",
    REPORT_VIEWER: "ReportViewer",
    DEVELOPER: "Developer"
};